import { AuthenticationContext, adalFetch, withAdalLogin } from "react-adal";

export const adalConfig = {
  tenant: "EYGS.onmicrosoft.com",
  clientId: "f0679316-d6b2-41a1-bead-0072031f2a7b",
  redirectUri: process.env.REACT_API_CLIENT_URL,
  endpoints: {
    api: "f0679316-d6b2-41a1-bead-0072031f2a7b",
  },
  cacheLocation: "localStorage",
};

export const authContext = new AuthenticationContext(adalConfig);

export const adalApiFetch = (fetch, url, options) =>
  adalFetch(authContext, adalConfig.endpoints.api, fetch, url, options);

export const withAdalLoginApi = withAdalLogin(
  authContext,
  adalConfig.endpoints.api
);

export const getToken = () => authContext.getCachedToken(adalConfig.clientId);

export function logout() {
  authContext.logOut();
}

export function acquireToken() {
  return new Promise(function (resolve, reject) {
    authContext.acquireToken(adalConfig.clientId, function (error, token) {
      if (error || !token) {
        reject(error);
      }

      resolve(token);
    });
  });
}

export const getCachedUser = authContext.getCachedUser();